import { getContext } from "@icg360/pi-syntax-tools";
import { createIterableInstance } from "../init/create-initial-state";
import { referenceTables } from "../reference-tables";
import { executeExpression } from "./execute-expressions";
import { tryExecSyntaxForExpression } from "./execute-syntax";
export function handleCount(state, exp) {
    const context = getContext({
        env: state.env,
        meta: referenceTables[state.key].model.meta,
        terms: state.terms,
        iterables: state.iterables,
        this: { iterable: state.iterables[exp.iterableName] },
    });
    const count = Number(tryExecSyntaxForExpression(exp.syntax, context, exp));
    if (Number.isNaN(count)) {
        throw new Error(`Invalid count for iterable ${exp.iterableName}`);
    }
    const safeCount = Math.min(Math.max(0, Math.ceil(count)), Number(referenceTables[state.key].model.iterables[exp.iterableName].max));
    state.iterables[exp.iterableName].count = safeCount;
    // The count for this iterable has been updated.
    if (safeCount === state.iterables[exp.iterableName].instances.length) {
        return;
    }
    // If it doesn't match the length of the
    // instances then we need to add or remove instances.
    while (safeCount > state.iterables[exp.iterableName].instances.length) {
        const { model, nodeToKey } = referenceTables[state.key];
        const indexToAdd = state.iterables[exp.iterableName].instances.length;
        state.iterables[exp.iterableName].instances.push(createIterableInstance(model, nodeToKey, exp.iterableName, indexToAdd));
        runAllExpressionsForEachInstance(state, model.iterables[exp.iterableName], [
            indexToAdd,
        ]);
    }
    while (safeCount < state.iterables[exp.iterableName].instances.length) {
        state.iterables[exp.iterableName].instances.pop();
    }
}
export function runAllExpressionsForEachInstance(state, iterable, iterableIndexes) {
    var _a;
    const queueExpressions = new Set();
    for (const termName of Object.keys(iterable.terms)) {
        const dependendents = (_a = referenceTables[state.key].termDependents.iterables[iterable.name]) === null || _a === void 0 ? void 0 : _a.terms[termName];
        if (!dependendents) {
            continue;
        }
        for (const exp of dependendents) {
            queueExpressions.add(exp);
        }
    }
    for (const exp of referenceTables[state.key].sortedReactiveExpressions) {
        const currentIterable = exp.iterableName === iterable.name;
        if ((currentIterable && exp.type !== "count") ||
            queueExpressions.has(exp)) {
            for (const iterableIndex of iterableIndexes) {
                executeExpression(state, exp, currentIterable
                    ? { iterableName: iterable.name, iterableIndex }
                    : undefined);
            }
        }
    }
}
//# sourceMappingURL=iterable-count.js.map